var is_250 = true;
var is_wireless = false;

let packages;
let plans;

var last_plan_id;
var selectedPackageId;

//Checking for reference, storing it to local if so.

/**
 * used only in this block
 * @param {String} parameterName
 * @returns {String|null}
 */
var findGetParameter = (parameterName) => {
  var result = null,
    tmp = [];
  var items = location.search.substr(1).split("&");
  for (var index = 0; index < items.length; index++) {
    tmp = items[index].split("=");
    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
  }
  return result;
};

const toggleSelectorPackage = (className = "", isOpen = false) => {
  const body = document.getElementsByTagName("body")[0];
  document.querySelectorAll(`.${className}`).forEach((menu) => {
    // set the top, then do the rest
    menu.style.setProperty("transition", "0s");
    menu.style.setProperty("top", window.scrollY + "px");
    menu.top = window.scrollY;
    requestAnimationFrame(() => {
      // set the transition
      menu.style.setProperty("transition", "0.3s ease-out");

      if (!isOpen) {
        menu.classList.toggle("closing", true);

        setTimeout(() => {
          menu.classList.toggle("closing", false);
          menu.classList.toggle("active", false);
        }, 300);
      } else {
        menu.classList.toggle("active", isOpen);
      }

      // lock the scroll
      body.classList.toggle("lock-scroll", isOpen);
    });
  });
};


const rebindPlanMenu = () => {
  // plan menu button
  document.querySelectorAll(".open-selector-button-plan").forEach((element) => {
    // console.log(element);
    element.addEventListener("click", () => {
      toggleSelectorPackage("nbn-selector-menu-plan", true);
    });
  });
  document.querySelectorAll(".close-selector-button-plan").forEach((element) =>
    element.addEventListener("click", () => {
      toggleSelectorPackage("nbn-selector-menu-plan", false);
    })
  );
  $(`#plansegment [data-bs-toggle="popover"]`).popover();
  last_plan_id = $(`.selector-option.plan.selected`).data("planid");
};


const updateSelectedPackage = (packageid) => {
  selectedPackageId = packageid;

  // here need to update the content of the package selection boxes, and then re-render the selected package
  updateNbnSection();

  // delelect all package
  document.querySelectorAll(".selector-option.package").forEach((element) => {
    element.classList.toggle("selected", false);
  });

  // select all of the package id
  document.querySelectorAll(`.selector-option.package[data-packageid=${packageid}]`).forEach((element) => {
    element.classList.toggle("selected", true);
  });
};


function updateNbnSection() {
  if ($(".nbn-select-package").length) {
    $("#plansegment").addClass("waiting");

    const params = [];
    location.search.substr(1).split("&").forEach(function (item) { params[item.split("=")[0]] = item.split("=")[1] });
    const isTestingNewOrderSystem = params['testingNewOrderSystem'] === 'true';

    Promise.all([
      new Promise((resolve, reject) => {
        $.ajax({
          url: ajax_url,
          type: "POST",
          data: {
            action: "GetNbnPlanForm",
            selected_bundle: selectedPackageId,
            plan_id: last_plan_id,
            is_wireless: Number(is_wireless),
            is_250: Number(is_250),
            isTestingNewOrderSystem: isTestingNewOrderSystem,
          },
          success: resolve,
          error: reject,
        });
      }),
      new Promise((resolve, reject) => {
        // a change must take at least `x` ms.
        let x = 200;
        setTimeout(resolve, x);
      }),
    ])
      .then((values) => {
        return values;
      })
      .then((values) => {
        let response = values[0];
        $("#plansegment").empty().append(response);
      })
      .catch((reason) => {
        //! not implimented
      })
      .finally(() => {
        rebindPlanMenu();
        updateSelectedPlan($(`.selector-option.plan.selected`).data("planid"));
        $("#plansegment").removeClass("waiting");
      });
  }
}

const updateSelectedPlan = (planid) => {
  // change the content of the plan / re-render the details
  // delelect all plans
  document.querySelectorAll(".selector-option.plan").forEach((element) => {
    element.classList.toggle("selected", false);
  });
  // select all of the plan id
  document.querySelectorAll(`.selector-option.plan[data-planid=${planid}]`).forEach((element) => {
    element.classList.toggle("selected", true);
  });

  // hide all
  document.querySelectorAll(`.nbn-plan-details`).forEach((element) => {
    element.classList.toggle("hidden", true);
  });
  // unhide selected
  $(`.nbn-plan-details[data-planid=${planid}]`).removeClass("hidden");
};

function wirelessCheck() {
  var service = "";
  if (localStorage.getItem("registered_service") != "" || localStorage.getItem("registered_service") !== null) {
    service = localStorage.getItem("registered_service");
  }
  if (localStorage.getItem(service + "_my_registered_address") == "" || localStorage.getItem(service + "_my_registered_address") === null) {
  } else {
    var address_json_type = $.parseJSON(localStorage.getItem(service + "_my_registered_address_json"));
    var type = address_json_type.serviceClassInfo ? address_json_type.serviceClassInfo.displayName.split("(") : [""];
    var stype = $.trim(type[0].toLowerCase());
    if (stype == "wireless") {
      is_wireless = true;
    } else {
      is_wireless = false;
    }
  }
}

function nbn250Check() {
  var service = "";
  if (localStorage.getItem("registered_service") != "" || localStorage.getItem("registered_service") !== null) {
    service = localStorage.getItem("registered_service");
  }
  if (localStorage.getItem(service + "_my_registered_address") == "" || localStorage.getItem(service + "_my_registered_address") === null) {
  } else {
    var address_json_type = $.parseJSON(localStorage.getItem(service + "_my_registered_address_json"));
    var technology_type = address_json_type.technologyType;
    //to lowercase
    technology_type = technology_type.toLowerCase();
    var allowed_technology_type = ["hfc", "fibre"];
    if (service == "nbn" && jQuery.inArray(technology_type, allowed_technology_type) >= 0) {
      is_250 = true;
    } else if (technology_type == "Wireless") {
      is_250 = false;
    } else {
      is_250 = false;
    }
  }
}


$(document).ready(function () {
  $(".address-search .address").keyup(
    delay(function () {
      const $this = $(this);
      const form = $(".address-search");

      if ($this.val()?.length > 3) {
        form.submit();
      }
    }, 500)
  );
  $("body").on("submit", ".address-search", function (e) {
    e.preventDefault();

    const $this = $(this);
    const address = $this.find("input[name=address]").val();

    search_for_address(address);
  });
  $("body").on("click", ".select-address", function (e) {
    e.preventDefault();

    var $this = $(this),
      address_id = $this.data("id"),
      address_title = $this.data("title"),
      address_json = $this.data("json");

    select_this_address(address_id, address_title, address_json);
  });
  $("body").on("click", ".change-address", function (e) {
    e.preventDefault();

    var $this = $(this),
      address_form = $(".address-search"),
      address_selected = $(".address-selected");

    address_selected.fadeOut();
    address_form.find(".change-address-cont").fadeOut();
    address_form.find(".address").val("").focus();
    updatePrice();
  });
  $("body").on("click", ".check-address", function (e) {
    e.preventDefault();

    var $this = $(this),
      address_id = $this.data("id"),
      address_title = $this.data("title"),
      address_json = $this.data("json");

    check_this_address(address_id, address_title, address_json);
  });
  $("body").on("click", ".revert-address,.clear-address", function (e) {
    e.preventDefault();
    $(".non_wireless_only").show();
    $(".wireless_only").hide();
    $(".nbn250_hide").hide();
    $(".nbn250_only").show();
    is_250 = true;
    is_wireless = false;
    updateNbnSection();

    var address_selected = $(".address-selected"),
      address_results = $(".address-search-results"),
      address_form = $(".address-search"),
      services_banner = $(".services-banner"),
      services_floating = $(".services-floating"),
      services_plans = $(".services-plans"),
      from = $("body").data("from");

    if (localStorage.getItem("registered_service") != "" || localStorage.getItem("registered_service") !== null) {
      from = localStorage.getItem("registered_service");
    }

    // check if has registered address
    if (localStorage.getItem(from + "_my_registered_address") == "" || localStorage.getItem(from + "_my_registered_address") === null) {
      alert("Something went wrong!!!");
    } else {
      localStorage.setItem("registered_service", "");
      localStorage.setItem(from + "_my_registered_address", "");
      localStorage.setItem(from + "_my_registered_address_json", "");
      localStorage.setItem(from + "_has_line", "");
      services_floating.find(".address").html("");
      services_floating.slideUp();
      services_banner.slideDown();
      services_plans.css("padding-top", 0);
    }
  });
  $("#successModal").on("hidden.bs.modal", function (e) {
    if ($("#typeModal").length) {
      $("#typeModal").modal("show");
    }
  });
  $(".phone-line").on("click", function (e) {
    e.preventDefault();

    var $this = $(this),
      has_line = $this.data("has-line"),
      from = $("body").data("from");

    localStorage.setItem(from + "_has_line", has_line);
    $("body").attr("data-line", has_line);
  });
  $("body").on("click", ".choose-plan", function (e) {
    e.preventDefault();
    var service = "";

    var $this = $(this),
      bundle = $(".plans .category .item.active").data("is-bundle"),
      plan = $this.data("plan"),
      from = $("body").data("from"),
      error_modal = $("#errorModal"),
      success_modal = $("#successModal"),
      type_modal = $("#typeModal"),
      sync_modal = $("#syncModal");


    //overwrite the from variable from the input fromIdOverride if it exists
    if ($("#fromIdOverride").length) {
      from = $("#fromIdOverride").val();
    }

    if (localStorage.getItem("registered_service") != "" || localStorage.getItem("registered_service") !== null) {
      service = localStorage.getItem("registered_service");
    }

    address_json_type = $.parseJSON(localStorage.getItem(service + "_my_registered_address_json"));

    if (
      localStorage.getItem(service + "_my_registered_address") == "" ||
      localStorage.getItem(service + "_my_registered_address") === null ||
      redirectFromNbnToAdsl(address_json_type.serviceClass, address_json_type.technologyType)
    ) {
      if (address_json_type !== null && redirectFromNbnToAdsl(address_json_type.serviceClass, address_json_type.technologyType)) {
        error_modal.modal("show");
      } else {
        error_modal.modal("show");
      }
    } else {
      //Adding outbrain tracking for click
      if (typeof obApi === "function") {
        obApi("track", "Choose Plan");
      }

      //Log

      $.ajax({
        type: "GET",
        url: ajax_url,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: {
          action: "log_action",
          type: "nbn_order_link",
          uq: Math.random,
        },
      });

      var address_json_data = $.parseJSON(localStorage.getItem(service + "_my_registered_address")),
        address_json_type = $.parseJSON(localStorage.getItem(service + "_my_registered_address_json")),
        address = address_json_data.address ? address_json_data.address : address_json_data.fullAddress,
        gnafId = address_json_data.id ? address_json_data.id : address_json_data.gnafId,
        type = address_json_type.serviceClassInfo ? address_json_type.serviceClassInfo.displayName.split("(") : [""];

      const classCode = (address_json_type.serviceClassInfo.classCode ? address_json_type.serviceClassInfo.classCode : '');
      const classTitle = classCodes[classCode] ? classCodes[classCode].title : '';

      if (from != service && service != "manual") {
        sync_modal.find(".title span").text(service);
        sync_modal.find(".type span").text(classTitle);
        sync_modal.find(".btn-" + service).fadeIn();
        if (classCodes[classCode] !== undefined) {
          var moreInfo = sync_modal.find(".type").children(".more-info");
          sync_modal.find(".type span").text(classCodes[classCode].title);
          moreInfo.find(".box .title").text(classCodes[classCode].title);
          moreInfo.find(".box .desc").text(classCodes[classCode].desc);
          moreInfo.fadeIn();
        }
        sync_modal.modal("show");
      } else {
        //Ref variable
        var materef = "";
        if (typeof getCookie("mate_ref_id") === "string") {
          materef = "&ibo=" + getCookie("mate_ref_id");
        }

        if (typeof getCookie("mate_jaicon_id") === "string") {
          materef += "&jcon=666";
        }

        // If ADSL check line first
        if (service == "adsl" && (localStorage.getItem(service + "_has_line") == "" || localStorage.getItem(service + "_has_line") === null)) {
          type_modal.modal("show");
        } else if (service == "manual") {
          // check if adsl then change
          // from variable base from
          // has line
          var line = "";
          if (service == "adsl") {
            line = $("body").attr("data-line").toString() === "true" ? "adsl-existing" : "adsl-new";
            service = line;
          }
          var url =
            "/orders/?from=nbn&address=" +
            encodeURIComponent(address) +
            "&serviceClass=" +
            encodeURIComponent(address_json_type.serviceClass) +
            "&newDevelopmentFee=" +
            encodeURIComponent(address_json_type.newDevelopmentFee) +
            "&productChoice=" +
            encodeURIComponent(plan) +
            "&addressId=" +
            encodeURIComponent(address_json_type.addressId) +
            "&gnafId=" +
            encodeURIComponent(gnafId) +
            "&bundle=" +
            encodeURIComponent(bundle) +
            "&sqFail=true&isManualFail=true" +
            materef;

          window.open(url, "_blank");
        } else {
          // check if adsl then change
          // from variable base from
          // has line
          var line = "";
          if (service == "adsl" || redirectFromNbnToAdsl(address_json_type.serviceClass, address_json_type.technologyType)) {
            if (redirectFromNbnToAdsl(address_json_type.serviceClass, address_json_type.technologyType)) {
              line = "adsl-new";
            } else {
              line = $("body").attr("data-line").toString() === "true" ? "adsl-existing" : "adsl-new";
            }

            service = line;
          }
          // address_json_type.serviceClass
          // So bundle is only the
          // thing to check.
          // console.log(bundle);
          //
          // console.log(localStorage);
          var url =
            "/orders/?from=" +
            encodeURIComponent(service) +
            "&address=" +
            encodeURIComponent(address) +
            "&serviceClass=" +
            encodeURIComponent(address_json_type.serviceClass) +
            "&newDevelopmentFee=" +
            encodeURIComponent(address_json_type.newDevelopmentFee) +
            "&productChoice=" +
            encodeURIComponent(plan) +
            "&addressId=" +
            encodeURIComponent(address_json_type.addressId) +
            "&gnafId=" +
            encodeURIComponent(gnafId) +
            "&bundle=" +
            encodeURIComponent(bundle) +
            "&sqFail=" +
            encodeURIComponent(address_json_type.sqFail) +
            "&isManualFail=false" +
            materef;

          window.open(url, "_blank");
        }
      }
    }
  });
  $("body").on("click", ".address-required", function (e) {
    e.preventDefault();

    var $this = $(this),
      address_form = $(".address-search"),
      services_banner = $(".services-banner");

      const headerHeight = $("header").outerHeight() || 0;

    $("html, body").animate(
      {
        scrollTop: services_banner.offset().top - headerHeight,
      },
      500
    );
  });

  function search_for_address(address) {
    var address_results = $(".address-search-results"),
      address_selected = $(".address-selected");

    $.ajax({
      type: "GET",
      url: ajax_url,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: {
        action: "search_for_address",
        address: address,
      },
      success: function (resp) {
        address_selected.fadeOut();
        address_results.html(resp.data);
        address_results.slideDown();
      },
    });
  }

  function select_this_address(id, title, json) {
    var address_selected = $(".address-selected"),
      address_results = $(".address-search-results"),
      address_form = $(".address-search");

    $.ajax({
      type: "GET",
      url: ajax_url,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: {
        action: "select_this_address",
        id: id,
        title: title,
        json: json,
      },
      success: function (resp) {
        address_form.find(".change-address-cont").fadeIn();
        address_results.slideUp();
        address_selected.html(resp.data);
        address_selected.fadeIn();
      },
    });
  }
  function check_this_address(id, title, json) {
    var address_selected = $(".address-selected"),
      address_results = $(".address-search-results"),
      address_form = $(".address-search"),
      services_banner = $(".services-banner"),
      services_floating = $(".services-floating"),
      services_plans = $(".services-plans"),
      success_modal = $("#successModal"),
      reject_modal = $("#rejectModal"),
      sync_modal = $("#syncModal"),
      from = $("body").data("from");
    if (from == "nbn_new") {
      from = "nbn";
    }
    $.ajax({
      type: "GET",
      url: ajax_url,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: {
        action: "check_this_address",
        id: id,
        title: title,
        json: json,
        from: from,
      },
      beforeSend: function () {
        $(".loader").fadeIn();
      },
      success: function (resp) {
        $(".loader").fadeOut();
        var json_data = $.parseJSON(resp.data),
          json_type = $.parseJSON(resp.json);
        var type = [""];
        if (json_type.serviceClassInfo && json_type.serviceClassInfo.displayName) {
          type = json_type.serviceClassInfo.displayName.split("(");
        }

        // Setting the defaults
        if (json_type.newDevelopmentFee == "TRUE") {
          // $("#feemodal").modal("show");
          sync_modal.find(".newdev").show();
          success_modal.find(".newdev").show();
        } else {
          // $("#feemodal").modal("hide");
          sync_modal.find(".newdev").hide();
          success_modal.find(".newdev").hide();
        }

        sync_modal.find(".status").text("success!");

        sync_modal.find(".desc").text("it looks like your place uses");

        //sync_modal
        //.find('.title')
        //.text('is available');
        sync_modal.find(".title").text("");

        sync_modal.find(".title").prepend("<span></span> ");

        success_modal.find(".desc").text("it looks like your place uses");

        sync_modal.find(".btn-nbn").hide();
        sync_modal.find(".btn-adsl").hide();
        // End defaults

        if ("serviceClassInfo" in json_type && "classCode" in json_type["serviceClassInfo"]) {
          var service_description = "";
          if (json_type["serviceClassInfo"]["classCode"] in serviceClasses) {
            service_description = serviceClasses[json_type["serviceClassInfo"]["classCode"]];
          }
          sync_modal.find(".timeframe").html(service_description);
          success_modal.find(".timeframe").html(service_description);
        } else {
          sync_modal.find(".timeframe").text("");
          success_modal.find(".timeframe").text("");
        }

        // type = json_type.serviceClassInfo ?
        // json_type.serviceClassInfo.displayName.split("(") : [''];

        if (resp.qualified == "PASS") {
          if (json_type.serviceClass !== undefined && redirectFromNbnToAdsl(json_type.serviceClass, json_type.technologyType)) {
            const modalBackgroundImage = "url(/includes/assets/img/webp/services/modal/whoops-person.webp)";
            const modalStatus = "sorry mate!";
            const modalTitle = "nbn&trade; is not available";
            const modalButtonText = "continue with an ADSL internet order";
            const modalButtonLink = "/adsl/";
            const modalDescriptionCommon =
              'ADSL internet may be available to you. contact our sales team on <a href="tel:13 14 13">13 14 13</a> or continue below with an ADSL order and our team will be in touch';
            const modalDescriptionHfc =
              '<br>nbn&trade; is <a style="display: inline" target="_blank" rel="noopener noreferrer" href="https://www.nbnco.com.au/utility/temporarily-limiting-the-number-of-HFC-connections">temporarily no longer taking new orders for HFC customers</a>';
            const modalDescriptionNbn = "<br>your address is not yet connected to the nbn&trade; network";

            success_modal.find(".img-before").css("background-image", modalBackgroundImage);
            success_modal.find(".img-before").css("background-size", "auto");
            success_modal.find(".img-before").css("background-position-x", "-73px");
            success_modal.find(".img-before").css("background-position-y", "71px");
            success_modal.find(".status").html(modalStatus);
            success_modal.find(".title").html(modalTitle);

            if (redirectFromNbnToAdsl(json_type.serviceClass, json_type.technologyType)) {
              if (json_type.technologyType === "HFC") {
                success_modal.find(".desc").html(modalDescriptionHfc);
              } else {
                success_modal.find(".desc").html(modalDescriptionNbn);
              }
            } else {
              success_modal.find(".desc").html("");
            }

            success_modal.find(".type").hide();
            success_modal.find(".timeframe").html(modalDescriptionCommon + "<br>");
            success_modal.find(".btn-yellow").attr("href", modalButtonLink);
            success_modal.find(".btn-yellow").data("dismiss", "modal");
            success_modal.find(".btn-yellow").html(modalButtonText);

            success_modal.modal("show");

            // console.log(resp);
          } else {
            const modalDefaultStatus = "success!";
            const modalDefaultBackgroundImage = "url(/includes/assets/img/webp/services/modal/success-person.webp)";
            const modalDefaultButtonText = "continue";
            const modalDefaultButtonLink = "javascript:void(0);";
            success_modal.find(".img-before").css("background-image", modalDefaultBackgroundImage);
            success_modal.find(".img-before").css("background-size", "unset");
            success_modal.find(".img-before").css("background-position-x", "unset");
            success_modal.find(".img-before").css("background-position-y", "unset");
            success_modal.find(".status").html(modalDefaultStatus);
            success_modal.find(".type").show();
            success_modal.find(".timeframe").html(service_description);
            success_modal.find(".btn-yellow").attr("href", modalDefaultButtonLink);
            success_modal.find(".btn-yellow").data("dismiss", "modal");
            success_modal.find(".btn-yellow").html(modalDefaultButtonText);

            var type = json_type.serviceClassInfo ? json_type.serviceClassInfo.displayName.split("(") : "",
              address = json_data.address ? json_data.address : json_data.fullAddress;

            const classCode = (json_type.serviceClassInfo.classCode ? json_type.serviceClassInfo.classCode : '');
            const classTitle = classCodes[classCode] ? classCodes[classCode].title : '';

            success_modal.find(".type span").text(classTitle);
            services_floating.find(".type").html(classTitle);

            if (json_type["serviceType"] == "ADSL") {
              success_modal.find(".title").text("nbn™ might be available");
              success_modal.find(".desc").text("give us a call on 13 14 13 to check nbn™ availability or continue with an adsl order below");
            } else {
              success_modal.find(".title").text("nbn™ is available");
            }
            // if (json_type.newDevelopmentFee == "TRUE") {
            //     $("#feemodal").on("hidden.bs.modal", function (e) {
            //         success_modal.modal("show");
            //     });
            // } else {
            success_modal.modal("show");
            // }
            if (classCodes[classCode] !== undefined) {
              var moreInfo = success_modal.find(".type").children(".more-info");
              success_modal.find(".type span").text(classCodes[classCode].title);
              moreInfo.find(".box .title").text(classCodes[classCode].title);
              moreInfo.find(".box .desc").text(classCodes[classCode].desc);
              moreInfo.fadeIn();
            }
          }

          localStorage.setItem("registered_service", resp.from);
          localStorage.setItem(resp.from + "_my_registered_address", resp.data);
          localStorage.setItem(resp.from + "_my_registered_address_json", resp.json);
          address_form.find(".change-address-cont").hide();
          address_results.html("").hide();
          address_selected.html("").hide();
          services_floating.find(".address").html(address);
          // services_floating.find(".type").html(classTitle);
          services_floating.slideDown();
          services_banner.slideUp();
          setTimeout(function () {
            // services_plans.css("padding-top", services_floating.outerHeight());
          }, 300);
          wirelessCheck();
          nbn250Check();
          updateNbnSection();
        } else if (resp.qualified == "MULTIPLE") {
          var addresses = resp.addresses;
          format_multiple_addresses(addresses, resp.from);
        } else {
          reject_modal.modal("show");
        }
      },
    });
  }

  // package menu button
  document.querySelectorAll(".open-selector-button-package").forEach((element) =>
    element.addEventListener("click", () => {
      toggleSelectorPackage("nbn-selector-menu-package", true);
    })
  );
  document.querySelectorAll(".close-selector-button-package").forEach((element) =>
    element.addEventListener("click", () => {
      toggleSelectorPackage("nbn-selector-menu-package", false);
    })
  );

  rebindPlanMenu();

  $(document).on("click", ".selector-option.package", function (e) {
    if ($(this).data("packageid") !== undefined) {
      updateSelectedPackage($(this).data("packageid"));
    }
  });

  $(document).on("click", ".selector-option.plan", function (e) {
    let planid = $(this).data("planid");
    if (planid !== undefined) {
      // if (planid == last_plan_id) {
      //   planid = null;
      // }
      last_plan_id = planid;
      updateSelectedPlan(planid);

      if ($(this).hasClass("mobile")) {
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $(`.nbn-plan-details[data-planid=${planid}]`).parent().offset().top - 50,
          },
          750
        );
      }
    }
  });

  last_plan_id = $(`.selector-option.plan.selected`).data("planid");
  selectedPackageId = $(".selector-option.package.selected").data("packageid");

  wirelessCheck();
  nbn250Check();

  updateNbnSection();
});